import MuiStepConnector from '@material-ui/core/StepConnector';
import styled from 'styled-components';

const StepperStatusConnector = styled(MuiStepConnector)`
  && {
    max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : 'auto')};

    &.MuiStepConnector-active {
      .MuiStepConnector-line {
        border-color: ${props => props.theme.palette.action.active};
      }
    }

    &.MuiStepConnector-completed {
      .MuiStepConnector-line {
        border-color: ${props => props.theme.palette.success.main};
      }
    }
  }
`;

export default StepperStatusConnector;
